import { useEffect, useState } from 'react';

import { getHtmlPreview } from '../../services/CampaignServices';

type useModalPreviewEmailCommunicationProps = {
	campaign: {
		id: string;
		communication: {
			type: string;
			message: string;
			useCustomTemplate: boolean;
		};
	};
};

export const useModalPreviewEmailCommunication = ({
	campaign,
}: useModalPreviewEmailCommunicationProps) => {
	const [isLoading, setLoading] = useState<boolean>(false);
	const [preview, setPreview] = useState<string>('');

	const b64DecodeUnicode = (encoded: string) => {
		return decodeURIComponent(
			window
				.atob(encoded)
				.split('')
				.map(function (c) {
					return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
				})
				.join(''),
		);
	};

	const fetchHtml = async () => {
		setLoading(true);
		try {
			const response = await getHtmlPreview(
				campaign.id,
				campaign.communication.type,
				campaign.communication.useCustomTemplate,
				campaign.communication.message,
			);
			setPreview(b64DecodeUnicode(response.data.content.mailTemplate));
		} catch (error) {
			setPreview('');
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchHtml();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { isLoading, preview };
};
